import script from "./BasketProductAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketProductAdd.vue?vue&type=script&setup=true&lang=js"

import "./BasketProductAdd.vue?vue&type=style&index=0&id=096087b3&scoped=true&lang=css"

import exportComponent from "/Users/darrenlumber/Sites/office-drop-craft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-096087b3"]])

export default __exports__